<template>
  <NuxtLink
    :to="props.actionButtonUrl"
    class="relative block w-full overflow-hidden rounded-lg bg-black text-white focus:outline-none focus:ring-2 focus:ring-gold-200"
    aria-labelledby="quizTitle"
    aria-describedby="quizDescription quizAction"
    id="marketing-card"
    external
  >
    <div class="group relative flex items-center justify-center rounded-[0.5714285714rem] after:block after:h-auto after:pb-[100%] after:content-[''] bg-opacity-25">
      <div
        class="absolute left-0 top-0 h-full w-full bg-cover"
        :style="`background-image: url('${props.backgroundImage || ''}')`"
        aria-hidden="true"
      ></div>
      <div class="absolute inset-0 bg-[rgba(25,25,25,0.7)]">
        <div class="relative flex h-full flex-col justify-end p-[1.5rem] before:pb-full">
          <div class="mb-5 text-2xl" aria-hidden="true">
            <Icon :icon="props.icon || 'clipboard'" class="font" size="lg" />
          </div>
          <div id="quizTitle" class="mb-3 text-xl font-medium text-white leading-5">
            {{ props.title }}
          </div>
          <p id="quizDescription" class="text-base text-white leading-5">
            {{ props.description }}
          </p>
          <p id="quizAction" class="mt-2 text-sm text-white underline leading-5">
            {{ props.actionButtonLabel || 'Explore Health Test' }}
          </p>
        </div>
      </div>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import Icon from '../../atom/icon.vue'
import type { MarketingCard } from '~~/shared/types/common'

const props = defineProps<MarketingCard>()
</script>
